var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourInternshipLearn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-358 -3102)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-889 -1866)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 40,
    rx: 12,
    transform: "translate(1247 4968)",
    fill: "#3488eb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(351.736 3112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.859,4.99a2.5,2.5,0,1,0-2.5-2.495A2.495,2.495,0,0,0,51.859,4.99Z",
    transform: "translate(-29.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.149,
    cy: 2.149,
    r: 2.149,
    transform: "translate(19.02 13.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.37,447.639a2.71,2.71,0,0,0-2.73,2.69l5.42.041A2.71,2.71,0,0,0,25.37,447.639Z",
    transform: "translate(-4.19 -428.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.149,
    cy: 2.149,
    r: 2.149,
    transform: "translate(26.133 13.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.033,447.639a2.71,2.71,0,0,0-2.73,2.69l5.42.041A2.71,2.71,0,0,0,193.033,447.639Z",
    transform: "translate(-164.741 -428.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.149,
    cy: 2.149,
    r: 2.149,
    transform: "translate(33.245 13.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.69,447.639a2.71,2.71,0,0,0-2.73,2.69l5.42.041A2.71,2.71,0,0,0,360.69,447.639Z",
    transform: "translate(-325.286 -428.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.864,143.421a3.8,3.8,0,0,0-3.239-3.782v.95H21.5v-.949a3.8,3.8,0,0,0-3.239,3.726v2.5h7.6v-2.442Zm-3.239-.169H21.5v-1.881h1.121Z",
    transform: "translate(0 -133.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.889,93.135a.692.692,0,1,0,.693.692A.692.692,0,0,0,285.889,93.135Z",
    transform: "translate(-255.61 -89.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.059,93.135a.692.692,0,1,0,.692.692A.693.693,0,0,0,415.059,93.135Z",
    transform: "translate(-379.301 -89.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.486,93.135a.692.692,0,1,0,.692.692A.692.692,0,0,0,350.486,93.135Z",
    transform: "translate(-317.467 -89.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.241.809h-4.694a3.241,3.241,0,0,0-3.237,3.237V5.31l-.729.431L176,6.674l1.553.98,1.19.752a3.234,3.234,0,0,0,2.8,1.621h4.694a3.241,3.241,0,0,0,3.237-3.237V4.046A3.241,3.241,0,0,0,186.241.809Zm2.115,5.98a2.116,2.116,0,0,1-2.115,2.116h-4.694A2.116,2.116,0,0,1,179.6,7.622l-1.451-.916,1.281-.756v-1.9a2.116,2.116,0,0,1,2.115-2.116h4.694a2.116,2.116,0,0,1,2.115,2.116Z",
    transform: "translate(-151.045 -0.775)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourInternshipLearn);
export default __webpack_public_path__ + "static/media/your-internship-learn.8e7a58989e58a6f5cb8d8a33b38e2e84.svg";
export { ForwardRef as ReactComponent };